import axios from "axios";
import { userService } from "./user.service.js";

const client = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000
});

client.interceptors.request.use(
  config => {
    const user = localStorage.getItem("user");
    if (user) {
      const token = JSON.parse(user).token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

client.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401) {
      userService.logout()
      window.location.href = "#/";
    }
    const erro = error.response && error.response.data.message
    return Promise.reject(erro);
  }
);

export default client;
